<template>
  <div style="height: 100%; background-color: #121212">
    <devices-dashboard-list @finishedloading="finishedloading" />
  </div>
</template>

<script>
import DevicesDashboardList from "./devicesDashboardList.vue"

export default {
  name: "DevicesDashboard",
  components: {
    DevicesDashboardList,
  },
  methods: {
    finishedloading() {
      this.$emit("finishedloading")
    },
  },
}
</script>
